import React from 'react';
import "./ScheduleSlot.scss";
import { Link } from 'react-router-dom';
import { getHours, currentTime } from '../../../helpers/datetime';

const ScheduleSlot = ({ slot, specialist, selectSlotsAction = null }) => {
    const startHour = getHours(slot.time_start);
    const endHour = getHours(slot.time_end);
    const lunch = getHours(1800);
        
    const duration = endHour - startHour - lunch;

    const startHourFormat = currentTime(slot.time_start);
    const endHourFormat = currentTime(slot.time_end);

    let totalHours = getHours(specialist.total_hours);
    const maxHours = specialist.preferences.working_hours_monthly_max;

    let hoursClass;
    if (totalHours > maxHours + 9 || (totalHours <= maxHours - 9 && totalHours > maxHours - 29)) {
        hoursClass = 'yellow';
    } else if (totalHours >= maxHours - 9 && totalHours <= maxHours + 9) {
        hoursClass = 'green';
    } else {
        hoursClass = 'red';
    }

    return (
        <div className="schedule-slot">
            <Link to={`/schedule/slot/${slot.id}/`}>
                <div
                    className={"schedule-slot__inner " + (slot.substitute && slot.substitute !== null ? "substitute" : "default")}
                    data-specialist-id={specialist.id}
                    onMouseEnter={selectSlotsAction(specialist.id, true)}
                    onMouseLeave={selectSlotsAction(specialist.id, false)}
                >
                    <div className="schedule-slot__specialist">{specialist.name}</div>
                    <div className="schedule-slot__hours-wrapper">
                        <div className="schedule-slot__time">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 7.00011H6.375V7.22639L6.51986 7.40022L7 7.00011ZM8.66272 9.97168L9.06283 10.4518L10.0231 9.6516L9.623 9.17146L8.66272 9.97168ZM7 3.71826H6.375V7.00011H7H7.625V3.71826H7ZM7 7.00011L6.51986 7.40022L8.66272 9.97168L9.14286 9.57157L9.623 9.17146L7.48014 6.6L7 7.00011Z" fill="black" />
                                <path d="M7.00051 12.4698C10.0214 12.4698 12.4703 10.0209 12.4703 7.00002C12.4703 3.97917 10.0214 1.53027 7.00051 1.53027C3.97966 1.53027 1.53076 3.97917 1.53076 7.00002C1.53076 10.0209 3.97966 12.4698 7.00051 12.4698Z" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span>{duration} ч.{!!specialist.total_hours && specialist.total_hours > 0 ? ' / ' : ''} <span className={`schedule-slot__total-hours ${hoursClass}`}>{totalHours > 0 ? totalHours + ' ч.' : ''}</span></span>
                        </div>
                        <div className="schedule-slot__hours">
                            <span>{startHourFormat} - {endHourFormat}</span>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default ScheduleSlot;